module.exports = __webpack_public_path__ + "images/dssLogo6.png";